/**
 * author: alvis
 * timestamp: 2026-05-12
 * description: Resolve whether reviewer external text is disclosed to Tenant/Contractor for UI checkbox state.
 * `leaveExternalComments` only means external text was saved; `showExternalCommentToContractor` is the persisted
 * disclosure flag updated on final approve (`syncReviewerExternalDisclosureByStatus`).
 * @param {Object} [detail]
 * @returns {boolean}
 */
export function resolveReviewerHistoryExternalDisclosedCheckbox (detail) {
  if (detail == null || typeof detail !== 'object') return false
  if (Object.prototype.hasOwnProperty.call(detail, 'showExternalCommentToContractor')) {
    return !!detail.showExternalCommentToContractor
  }
  return !!detail.leaveExternalComments
}
